/**
 * @generated SignedSource<<4c80a56cc32d83f2adeb9cd0da4cf259>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactAttributesPanel_contact$data = {
  readonly attributes: ReadonlyArray<{
    readonly name: string;
    readonly value: string;
  }>;
  readonly id: string;
  readonly " $fragmentType": "ContactAttributesPanel_contact";
};
export type ContactAttributesPanel_contact$key = {
  readonly " $data"?: ContactAttributesPanel_contact$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContactAttributesPanel_contact">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactAttributesPanel_contact",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContactAttribute",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Contact",
  "abstractKey": "__isContact"
};

(node as any).hash = "a29f6ff5572ee71ddd4940fb1aae5487";

export default node;
